export default "<ion-content>\n  \n  <div #youtubePlayer class=\"video-container\"></div>\n  \n</ion-content>";